import * as Types from '../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import { ShopLocationContextFragmentDoc } from '../../WorkOrdersPage/Contexts/__generated__/ShopLocationsContext.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetShopLocationsForContextQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetShopLocationsForContextQuery = { __typename?: 'Query', getShopLocations: Array<{ __typename?: 'ShopLocation', id: string, name: string }> };


export const GetShopLocationsForContextDocument = gql`
    query GetShopLocationsForContext {
  getShopLocations {
    ...ShopLocationContext
  }
}
    ${ShopLocationContextFragmentDoc}`;

/**
 * __useGetShopLocationsForContextQuery__
 *
 * To run a query within a React component, call `useGetShopLocationsForContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopLocationsForContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopLocationsForContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShopLocationsForContextQuery(baseOptions?: Apollo.QueryHookOptions<GetShopLocationsForContextQuery, GetShopLocationsForContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopLocationsForContextQuery, GetShopLocationsForContextQueryVariables>(GetShopLocationsForContextDocument, options);
      }
export function useGetShopLocationsForContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopLocationsForContextQuery, GetShopLocationsForContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopLocationsForContextQuery, GetShopLocationsForContextQueryVariables>(GetShopLocationsForContextDocument, options);
        }
export function useGetShopLocationsForContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShopLocationsForContextQuery, GetShopLocationsForContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShopLocationsForContextQuery, GetShopLocationsForContextQueryVariables>(GetShopLocationsForContextDocument, options);
        }
export type GetShopLocationsForContextQueryHookResult = ReturnType<typeof useGetShopLocationsForContextQuery>;
export type GetShopLocationsForContextLazyQueryHookResult = ReturnType<typeof useGetShopLocationsForContextLazyQuery>;
export type GetShopLocationsForContextSuspenseQueryHookResult = ReturnType<typeof useGetShopLocationsForContextSuspenseQuery>;
export type GetShopLocationsForContextQueryResult = Apollo.QueryResult<GetShopLocationsForContextQuery, GetShopLocationsForContextQueryVariables>;